import { render, staticRenderFns } from "./MagenteForm.vue?vue&type=template&id=0113ed90"
import script from "./MagenteForm.vue?vue&type=script&lang=js"
export * from "./MagenteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports